// extracted by mini-css-extract-plugin
export default {"typography":"style_typography__uwGHl"};